import { Link } from 'react-router-dom';
import projects, { tags } from '../data/projects';
import Nav from './Nav';
import Footer from './Footer';
import './ProjectsPage.scss';

const ProjectsPage = () => (
  <div className="projects-page">
    <Nav alwaysVisible />

    <div className="projects-page__hero">
      <h1 className="projects-page__title">MES PROJETS</h1>
    </div>

    <div className="projects-page__content">
      <div className="projects-page__grid">
        {projects.map(({ id, slug, title, logo, logoHeight, logoInvert, img, tags: projectTags }) => (
          <Link to={`/projet/${slug}`} className="projects-page__item" key={id}>
            <div className="projects-page__img" style={{ backgroundImage: `url(${img})` }} />
            <div className="projects-page__overlay">
              <span className="projects-page__num">{id}</span>
              <div className="projects-page__info">
                {logo
                  ? <img src={logo} alt={title} className="projects-page__logo" style={{ ...(logoHeight ? { height: `${logoHeight}px` } : {}), ...(logoInvert ? { filter: 'brightness(0) invert(1)' } : {}) }} />
                  : <p className="projects-page__name">{title}</p>
                }
                <div className="projects-page__tags">
                  {(projectTags || tags).map(tag => (
                    <span className="projects-page__tag" key={tag}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>

    <Footer />
  </div>
);

export default ProjectsPage;
